export function trimInput(value) {
  if (value === "" || value === undefined || value === false) {
    return null;
  } else if (value === null) {
    return value;
  } else {
    return value.trim();
  }
}
